import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Star, Shield, Info, Ticket, Crown, Diamond, Award, Users, Globe, Newspaper, MessageSquare, Megaphone, Presentation, Calendar, Mail, Utensils, Store } from 'lucide-react';
import { Link } from 'react-router-dom';

const sponsorsData = {
  headline: [
    {
      id: 1,
      name: "Vodacom Business",
      logo: "https://titc.io/wp-content/uploads/2025/11/VB_Further_together_StackedUp_logo-01.png",
      description: "A Leading Business Communications & Technology enabler, your platform for Fintech Innovation"
    }
  ],
  gold: [
    {
      id: 2,
      name: "Royal Park Partners",
      logo: "https://static.wixstatic.com/media/cde47b_9e718feaaaf8453aa4edf0c5ea1af5d6~mv2.png",
      description: "Global FinTech Investment Banking Advisory"
    },
    {
      id: 3,
      name: "BDO",
      logo: "https://cdn.bdo.global/images/bdo_logo/1.0.0/bdo_logo_color.png",
      description: "Professional Services & Advisory"
    }
  ],
  category: [
    {
      id: 4,
      name: "Tether",
      logo: "https://tether.to/images/logoGreen.png",
      description: "Digital Currency & Blockchain Solutions"
    },
    {
      id: 6,
      name: "Everest Wealth",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSi2Atdt5FCghRCKO6V5AkL5p7bz0h2DQ_41Q&s",
      description: "Wealth Management & Financial Services"
    },

    {
      id: 8,
      name: "Liquid C2",
      logo: "https://liquidc2.com/wp-content/uploads/sites/3//2022/11/C2-H-AH.svg",
      description: "Digital Banking & Payment Solutions Provider"
    }
  ],
  table: [
    {
      id: 8,
      name: "Peach Payments",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTn7iBUJ0Sr-HXbTSiCBqnyIMslZ_URL_4eFA&s",
      description: "Payment Processing Solutions"
    },
    {
      id: 9,
      name: "Investec",
      logo: "https://static.wixstatic.com/media/cf215e_c32a4b4a3b5745d1be07079099d2455e~mv2.png/v1/fill/w_900,h_500,al_c/cf215e_c32a4b4a3b5745d1be07079099d2455e~mv2.png",
      description: "Banking & Wealth Management"
    },
    {
      id: 10,
      name: "Adumo",
      logo: "https://www.investec.com/content/dam/south-africa/corporates-and-institutions/adumo_934x526.jpg",
      description: "Payment Solutions Provider"
    },
    {
      id: 11,
      name: "TransUnion",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8ob435isjIJxvaFUQPX4j6CSvjFvaWUY3Mg&s",
      description: "Credit Information & Risk Management Solutions"
    }
  ]
};

const sponsorshipTiers = [
  {
    name: "Headline Partner",
    price: "R1,500,000 + VAT",
    icon: <Crown className="h-12 w-12" />,
    color: "bg-gradient-to-br from-purple-600 to-purple-800",
    benefits: [
      "Exclusive headline sponsor recognition across all materials",
      "Prime logo placement on all event communications and signage",
      "Keynote speaking opportunity at the main event",
      "Private VIP networking suite with dedicated hospitality",
      "15 premium tickets with exclusive access privileges"
    ],
    highlights: [
      "Exclusive media interviews and press coverage",
      "Custom branded welcome reception",
      "Post-event comprehensive analytics report",
      "Year-long partnership recognition"
    ]
  },
  {
    name: "Platinum Partner",
    price: "R995,000 + VAT",
    icon: <Crown className="h-12 w-12" />,
    color: "bg-gradient-to-br from-gray-300 to-gray-500",
    benefits: [
      "Top-tier logo placement on all event materials, banners, brochures, and communications",
      "Prominent branding on stage backdrops and speaker podiums",
      "Private networking suite for one-on-one meetings",
      "Keynote address opportunity",
      "Sponsor exclusive pre-gala drinks and post-event lunch"
    ],
    highlights: [
      "10 facilitated introductions to key attendees",
      "Inclusion in press releases and media coverage",
      "Featured advertising across all platforms",
      "Comprehensive analytics and ROI report"
    ]
  },
  {
    name: "Gold Partner",
    price: "R500,000 + VAT",
    icon: <Trophy className="h-12 w-12" />,
    color: "bg-gradient-to-br from-yellow-500 to-yellow-600",
    benefits: [
      "Prominent logo placement on select event materials",
      "Co-sponsor the official after-party with welcome speech",
      "5 facilitated introductions to key attendees",
      "Keynote or high-impact session participation",
      "10 VIP passes with exclusive access"
    ],
    highlights: [
      "Media coverage and interview opportunities",
      "Branded items in event gift bags",
      "Digital platform visibility",
      "Post-event insights report"
    ],
    remaining: 1
  },
  {
    name: "Silver Partner",
    price: "R330,000",
    icon: <Shield className="h-12 w-12" />,
    color: "bg-gradient-to-br from-gray-400 to-gray-600",
    benefits: [
      "Logo placement on session slides and signage",
      "Event announcement recognition",
      "Branded items in gift bags",
      "5 event tickets",
      "Exclusive networking session access"
    ],
    highlights: [
      "Media communications inclusion",
      "Website and social media recognition",
      "Post-event report access",
      "Newsletter and email features"
    ]
  },
  {
    name: "Category Sponsor",
    price: "R95,000 + VAT",
    icon: <Award className="h-12 w-12" />,
    color: "bg-gradient-to-br from-indigo-500 to-indigo-600",
    benefits: [
      "Present award on stage",
      "Branded award with company name and logo",
      "Dedicated photoshoot with nominees and winner",
      "Pre and post-event communications mention"
    ],
    highlights: [
      "Social media promotion",
      "One-on-one meeting with winner",
      "Brand visibility during ceremony",
      "Category-specific recognition"
    ]
  }
];

const Sponsors = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden" style={{ backgroundColor: '#1A1A1A' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <h1 className="text-5xl font-bold mb-6" style={{ color: '#C1B3A3' }}>
              Our Sponsors
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Partnering with industry leaders to celebrate excellence in South African FinTech
            </p>
          </motion.div>
        </div>
      </section>

      {/* Current Sponsors Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Headline Sponsor */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-20"
          >
            <div className="flex items-center justify-center mb-12">
              <Crown className="h-8 w-8 mr-3" style={{ color: '#C1B3A3' }} />
              <h2 className="text-3xl font-bold">Headline Sponsor</h2>
            </div>
            <div className="max-w-4xl mx-auto">
              <div className="flex justify-center">
                {sponsorsData.headline.map((sponsor, index) => (
                  <motion.div
                    key={sponsor.id}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.2 }}
                    className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-2xl overflow-hidden hover:shadow-3xl transition-all duration-500 transform hover:-translate-y-2 w-full max-w-3xl border-2 border-gray-100"
                  >
                    <div className="h-72 flex items-center justify-center p-12 bg-white">
                      <img
                        src={sponsor.logo}
                        alt={sponsor.name}
                        className="max-h-full max-w-full object-contain filter hover:brightness-110 transition-all duration-300"
                      />
                    </div>
                    <div className="p-8 border-t-2 border-gray-100">
                      <h3 className="text-3xl font-bold mb-4 text-center" style={{ color: '#1A1A1A' }}>{sponsor.name}</h3>
                      <p className="text-lg text-gray-600 mb-6 text-center">{sponsor.description}</p>
                      <div className="text-center">
                        <div className="inline-flex items-center px-6 py-3 rounded-full text-white font-semibold text-lg"
                             style={{ backgroundColor: '#C1B3A3' }}>
                          <Crown className="h-5 w-5 mr-2" />
                          <span>Headline Partner</span>
                        </div>
                      </div>
                    </div>
                    <div className="h-3 bg-gradient-to-r from-red-600 via-red-500 to-red-600"></div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Gold Sponsors */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-20"
          >
            <div className="flex items-center justify-center mb-12">
              <Trophy className="h-8 w-8 mr-3" style={{ color: '#C1B3A3' }} />
              <h2 className="text-3xl font-bold">Gold Sponsors</h2>
            </div>
            <div className="max-w-4xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 justify-items-center">
                {sponsorsData.gold.map((sponsor, index) => (
                  <motion.div
                    key={sponsor.id}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.2 }}
                    className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 w-full max-w-md"
                  >
                    <div className="h-32 flex items-center justify-center p-6">
                      <img
                        src={sponsor.logo}
                        alt={sponsor.name}
                        className="max-h-full max-w-full object-contain"
                      />
                    </div>
                    <div className="p-6 border-t">
                      <h3 className="text-xl font-bold mb-2">{sponsor.name}</h3>
                      <p className="text-gray-600 mb-4">{sponsor.description}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Category Sponsors */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center justify-center mb-12">
              <Star className="h-8 w-8 mr-3" style={{ color: '#C1B3A3' }} />
              <h2 className="text-3xl font-bold">Category Sponsors</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
              {sponsorsData.category.map((sponsor, index) => (
                <motion.div
                  key={sponsor.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2 }}
                  className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                >
                  <div className="h-32 flex items-center justify-center p-6">
                    <img
                      src={sponsor.logo}
                      alt={sponsor.name}
                      className="max-h-full max-w-full object-contain"
                    />
                  </div>
                  <div className="p-6 border-t">
                    <h3 className="text-xl font-bold mb-2">{sponsor.name}</h3>
                    <p className="text-gray-600 mb-4">{sponsor.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Table Sponsors */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center justify-center mb-12">
              <Utensils className="h-8 w-8 mr-3" style={{ color: '#C1B3A3' }} />
              <h2 className="text-3xl font-bold">Table Sponsors</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
              {sponsorsData.table.map((sponsor, index) => (
                <motion.div
                  key={sponsor.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2 }}
                  className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                >
                  <div className="h-32 flex items-center justify-center p-6">
                    <img
                      src={sponsor.logo}
                      alt={sponsor.name}
                      className="max-h-full max-w-full object-contain"
                    />
                  </div>
                  <div className="p-6 border-t">
                    <h3 className="text-xl font-bold mb-2">{sponsor.name}</h3>
                    <p className="text-gray-600 mb-4">{sponsor.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Powered by Range Rover Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-20"
          >
            <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-2xl p-12 text-center">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="max-w-2xl mx-auto"
              >
                <h3 className="text-2xl font-bold text-white mb-8">Powered by</h3>
                <div className="bg-white rounded-xl p-8 shadow-xl">
                  <img
                    src="https://titc.io/wp-content/uploads/2025/07/L46000GL_303103837_devicemark_Slate_Blue_RGB_png.png"
                    alt="Range Rover"
                    className="max-h-20 mx-auto object-contain"
                  />
                </div>
                <p className="text-gray-300 mt-6 text-lg">
                  Proudly supported by Range Rover, driving excellence in luxury and innovation
                </p>
              </motion.div>
            </div>
          </motion.div>

          {/* Sponsorship Opportunities */}
          <section className="py-20 bg-gray-50 -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="max-w-4xl mx-auto text-center mb-16"
            >
              <h2 className="text-4xl font-bold mb-6">Sponsorship Opportunities</h2>
              <p className="text-xl text-gray-600">
                Join us in shaping the future of African FinTech. Our sponsorship packages offer 
                unparalleled exposure to the continent's most innovative financial technology leaders.
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
              {sponsorshipTiers.map((tier, index) => (
                <motion.div
                  key={tier.name}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2 }}
                  className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 relative"
                >
                  {tier.remaining === 1 && (
                    <div className="absolute top-4 right-4 z-10">
                      <div className="bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full animate-pulse">
                        Only 1 Remaining
                      </div>
                    </div>
                  )}
                  <div className={`${tier.color} p-6 text-white text-center`}>
                    <div className="inline-block p-3 rounded-full bg-white/10 backdrop-blur-sm mb-4">
                      {tier.icon}
                    </div>
                    <h3 className="text-2xl font-bold mb-2">{tier.name}</h3>
                    <p className="text-3xl font-bold">{tier.price}</p>
                  </div>
                  <div className="p-6">
                    <div className="mb-6">
                      <h4 className="font-semibold mb-4">Core Benefits:</h4>
                      <ul className="space-y-3">
                        {tier.benefits.map((benefit, idx) => (
                          <li key={idx} className="flex items-start">
                            <Star className="h-5 w-5 text-yellow-500 mr-2 flex-shrink-0 mt-0.5" />
                            <span className="text-gray-600">{benefit}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h4 className="font-semibold mb-4">Additional Highlights:</h4>
                      <ul className="space-y-3">
                        {tier.highlights.map((highlight, idx) => (
                          <li key={idx} className="flex items-start">
                            <Shield className="h-5 w-5 text-indigo-500 mr-2 flex-shrink-0 mt-0.5" />
                            <span className="text-gray-600">{highlight}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>

            {/* Exhibition Space Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="max-w-4xl mx-auto mt-20"
            >
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  <div className="p-8">
                    <div className="flex items-center mb-6">
                      <Store className="h-8 w-8 mr-3" style={{ color: '#C1B3A3' }} />
                      <h3 className="text-2xl font-bold">Exhibition Space</h3>
                    </div>
                    <p className="text-gray-600 mb-6">
                      Showcase your brand in our carefully curated exhibition area, strategically positioned 
                      within the main networking space for maximum visibility and engagement.
                    </p>
                    <div className="space-y-4 mb-8">
                      <div className="flex items-center space-x-3">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center">
                          <Users className="h-4 w-4 text-indigo-600" />
                        </div>
                        <p className="text-gray-700">Direct access to 500+ industry leaders</p>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center">
                          <Globe className="h-4 w-4 text-indigo-600" />
                        </div>
                        <p className="text-gray-700">Premium location in main networking area</p>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center">
                          <Star className="h-4 w-4 text-indigo-600" />
                        </div>
                        <p className="text-gray-700">Exclusive, limited availability (10 spaces only)</p>
                      </div>
                    </div>
                    <div className="bg-indigo-50 rounded-lg p-6">
                      <p className="text-2xl font-bold text-indigo-600 mb-2">R150,000 + VAT</p>
                      <p className="text-gray-600">Limited to 10 exhibition spaces</p>
                    </div>
                  </div>
                  <div className="relative h-full min-h-[400px]">
                    <img
                      src="https://titc.io/wp-content/uploads/2025/04/1A_high-resolution_digital_photograph_captures_an_e.png"
                      alt="Exhibition Space"
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-8">
                      <p className="text-white text-lg font-medium">
                        Position your brand at the heart of South Africa's premier FinTech gathering
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Sponsorship Benefits Grid */}
            <div className="max-w-7xl mx-auto mt-20">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center mb-12"
              >
                <h3 className="text-3xl font-bold mb-6">Why Sponsor?</h3>
                <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                  Maximize your brand's visibility and connect with South Africa's most influential FinTech leaders
                </p>
              </motion.div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {[
                  {
                    icon: <Users className="h-8 w-8" />,
                    title: "Access & Networking",
                    description: "Connect with 500+ C-suite executives, innovators, and investors shaping Africa's financial future"
                  },
                  {
                    icon: <Globe className="h-8 w-8" />,
                    title: "Brand Exposure",
                    description: "Reach a highly targeted audience of FinTech decision-makers"
                  },
                  {
                    icon: <Newspaper className="h-8 w-8" />,
                    title: "Media Coverage",
                    description: "Featured in press releases and media coverage across Africa"
                  },
                  {
                    icon: <MessageSquare className="h-8 w-8" />,
                    title: "Thought Leadership",
                    description: "Position your brand as a leader in financial innovation"
                  },
                  {
                    icon: <Megaphone className="h-8 w-8" />,
                    title: "Marketing Impact",
                    description: "Comprehensive digital and physical marketing presence"
                  },
                  {
                    icon: <Presentation className="h-8 w-8" />,
                    title: "Speaking Opportunities",
                    description: "Share your insights with an engaged audience"
                  }
                ].map((benefit, index) => (
                  <motion.div
                    key={benefit.title}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 }}
                    className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                    <div className="mb-4" style={{ color: '#C1B3A3' }}>
                      {benefit.icon}
                    </div>
                    <h4 className="text-xl font-bold mb-2">{benefit.title}</h4>
                    <p className="text-gray-600">{benefit.description}</p>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* Important Dates */}
            <div className="max-w-4xl mx-auto mt-20">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="bg-white rounded-2xl shadow-xl p-8"
              >
                <div className="flex items-center justify-center mb-6">
                  <Calendar className="h-8 w-8 mr-3" style={{ color: '#C1B3A3' }} />
                  <h3 className="text-2xl font-bold">Important Dates</h3>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="text-center p-4 rounded-lg bg-gray-50">
                    <p className="font-semibold mb-2">Sponsorship Commitment Deadline</p>
                    <p className="text-gray-600">September 30, 2025</p>
                  </div>
                  <div className="text-center p-4 rounded-lg bg-gray-50">
                    <p className="font-semibold mb-2">Sponsorship Duration</p>
                    <p className="text-gray-600">12 months from signing</p>
                  </div>
                </div>
              </motion.div>
            </div>
          </section>
        </div>
      </section>
    </div>
  );
};

export default Sponsors;